import { appstr } from "./appstr";
import type { QObjDBFieldDef } from "../CoreApp/QObjDBFieldDef";

export function GetFieldLabel(fieldDef: QObjDBFieldDef | null, affixObjectLabel = false): string {
  let displayName = fieldDef?.GetFieldLabel();

  if (displayName == null || displayName.length == 0) {
    displayName = fieldDef?.GetFieldDisplayName() || "";
  }

  if (!affixObjectLabel) {
    return displayName;
  }

  const docRef = fieldDef?.GetDocRef();
  if (!docRef?.IsPositionDocument()) {
    return displayName;
  }

  let suffix = "";

  const fieldClassName = fieldDef?.GetFieldClassName();
  if (fieldClassName === "Box") {
    suffix = ` (${appstr("Employee").toLocaleLowerCase()})`;
  } else if (fieldClassName === "Position") {
    suffix = ` (${appstr("Position").toLocaleLowerCase()})`;
  }

  return `${displayName}${suffix}`;
}
